(() => {
  const SALE_RE = /^sale\s*%?$/i;
  const MOBILE_QUERY = '(max-width: 749px)';

  function markSaleLinks(root = document) {
    const selectors = [
      '.menu-list__link',
      '.menu-drawer__menu-item',
      '.menu-list--mobile .menu-list__item'
    ];

    root.querySelectorAll(selectors.join(',')).forEach((link) => {
      const text = (link.textContent || '').trim();
      if (SALE_RE.test(text)) link.classList.add('aw-sale-link');
    });
  }

  function installEditableMobileMenu() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    const source = document.querySelector('#AbayaweltMobileNavigationSource');
    const drawer = document.querySelector('#Details-menu-drawer-container');
    const target = drawer?.querySelector('.menu-drawer__navigation > .menu-drawer__menu.has-submenu');

    if (!source || !target || target.dataset.awMobileMenuInstalled === 'true') return;

    target.replaceChildren(source.content.cloneNode(true));
    target.dataset.awMobileMenuInstalled = 'true';
  }

  function setupMobileAccordions(root = document) {
    const drawer =
      root.querySelector?.('#Details-menu-drawer-container') ||
      document.querySelector('#Details-menu-drawer-container');

    if (!drawer) return;

    drawer.querySelectorAll('.menu-drawer__list-item--flat').forEach((item) => {
      const trigger = item.querySelector(
        ':scope > .menu-drawer__menu-item--mainlist, :scope > .menu-drawer__menu-item--parent'
      );
      const childList = item.querySelector(
        ':scope > .menu-drawer__menu--childlist, :scope > .menu-drawer__menu--grandchildlist'
      );

      if (!trigger || !childList) return;

      item.classList.add('aw-mobile-accordion-parent');
      trigger.setAttribute(
        'aria-expanded',
        item.classList.contains('aw-mobile-accordion-open') ? 'true' : 'false'
      );
      trigger.setAttribute('role', 'button');

      if (!trigger.querySelector('.aw-mobile-accordion-indicator')) {
        const indicator = document.createElement('span');
        indicator.className = 'aw-mobile-accordion-indicator';
        indicator.setAttribute('aria-hidden', 'true');
        indicator.innerHTML =
          '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M5 7.5 10 12.5 15 7.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(indicator);
      }

      if (trigger.dataset.awAccordionBound === 'true') return;
      trigger.dataset.awAccordionBound = 'true';

      trigger.addEventListener('click', (event) => {
        if (!window.matchMedia(MOBILE_QUERY).matches) return;

        event.preventDefault();

        const isOpen = item.classList.toggle('aw-mobile-accordion-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }

  function setupCartFallback() {
    document.querySelectorAll('[data-testid="cart-drawer-trigger"]').forEach((trigger) => {
      if (trigger.dataset.awCartFallbackBound === 'true') return;
      trigger.dataset.awCartFallbackBound = 'true';

      trigger.addEventListener('click', () => {
        window.setTimeout(async () => {
          const cartDrawer = document.querySelector('#cart-drawer');
          if (!cartDrawer || cartDrawer.hasAttribute('open')) return;

          try {
            await customElements.whenDefined('theme-drawer');
            if (!cartDrawer.hasAttribute('open') && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          } catch (_) {
            // Keep Horizon's native cart behavior as the primary path.
          }
        }, 60);
      });
    });
  }

  function refreshCustomHeader() {
    installEditableMobileMenu();
    setupMobileAccordions();
    setupCartFallback();
    markSaleLinks();
  }

  function init() {
    refreshCustomHeader();

    const header = document.querySelector('#header-component');
    if (!header) return;

    const observer = new MutationObserver(() => {
      refreshCustomHeader();
    });

    observer.observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
